export const baseURL = "https://greedylion.ajobfun.store/";
export const adminBaseURL = "https:///";
export const key = "";
